import { IUserState } from "./reducer";

export const USER_LOGIN = "user/api/USER_LOGIN";
export const USER_LOGIN_SUCCESS = "user/api/USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAILURE = "user/api/USER_LOGIN_FAILURE";

export const USER_LOGOUT = "user/api/USER_LOGOUT";
export const USER_LOGOUT_FAILURE = "user/api/USER_LOGOUT_FAILURE";

export const userLogin = () => ({
  type: USER_LOGIN
});

export const userLoginSuccess = (user: IUserState) => ({
  type: USER_LOGIN_SUCCESS,
  payload: user
});

export const userLoginFailure = () => ({
  type: USER_LOGIN_FAILURE
});

export const userLogout = () => ({
  type: USER_LOGOUT
});

export const userLogoutFailure = () => ({
  type: USER_LOGOUT_FAILURE
});



// WEBPACK FOOTER //
// ./client/modules/User/actions.ts